import { useEffect, useRef } from "react";

/** Start a nested confirmation on Cancel, then return to its still-mounted opener. */
export function useDialogCancelFocus(): React.RefObject<HTMLButtonElement | null> {
  const cancel = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    const opener = document.activeElement;
    cancel.current?.focus();
    return () => {
      if (opener instanceof HTMLElement && opener.isConnected) opener.focus();
    };
  }, []);
  return cancel;
}
